<template>
  <div>
    <!-- <current-path /> -->
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.questions") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn @click="dialog = !dialog" class="primary">
        <v-icon>mdi-plus</v-icon>
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      @get_items="getItems"
      ref="table_ref"
      :headersName="headers"
      pathName="questions"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center" :title="item.text">
          {{ item.text | truncate }}
        </td>
        <td class="text-sm-center" :title="item.hint">
          {{ item.hint | truncate }}
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="questions"
            :model-id="item.id"
            field="visible"
            v-model="item.is_visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <v-icon
            @click="handleShow(item, index)"
            :title="$t('icon.edit')"
            small
            >mdi-pencil</v-icon
          >
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
    <v-dialog v-model="dialog" max-width="700">
      <v-card>
        <v-card-title class="dialog_header">
          {{ formTitle }}
        </v-card-title>
        <v-card-text>
          <FormAction
            :dialog="dialog"
            :form="form"
            :v="$v"
            :isEdit="isEdit"
            :item="this.item"
            @on-submited="onSubmited"
            @on-locale-change="onLocaleChange"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ShowData } from "@/helpers/apiMethods";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { maxWords } from "@/utils/validate";
import cookie from "js-cookie";
export default {
  name: "Questions",
  components: {
    FormAction: () => import("./formAction"),
  },

  data() {
    return {
      headers: ["text", "hint", "visible", "actions"],
      isEdit: false,
      loadingButton: false,
      items: [],
      item: {},
      itemIndex: null,
      locale: this.locale,
      dialog: false,
      form: {
        text: "",
        hint: "",
        is_visible: 0,
        question_group_id: "",
      },
    };
  },
  methods: {
    onLocaleChange(locale) {
      this.locale = locale;

      this.handleShowData();
    },
    onSubmited(data) {
      if (!this.itemIndex) {
        this.items.push(data);
      } else {
        this.$set(this.items, this.itemIndex, data);
      }
      this.dialog = !this.dialog;
    },
    getItems(items) {
      this.items = items;
    },
    handleOpenDialog() {
      this.$refs.table_ref.toggleDialog();
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleShow(item, index) {
      this.isEdit = true;
      this.item = item;
      this.itemIndex = index;
      this.dialog = !this.dialog;
      this.handleShowData();
    },
    resetData() {
      this.form = {
        text: "",
        hint: "",
        is_visible: 0,
        question_group_id: "",
      };
      this.$v.form.$reset();
      this.isEdit = false;
      this.locale = cookie.get("language");
    },
    handleShowData() {
      ShowData({
        reqName: "questions",
        param: this.item.id,
        locale: this.locale,
      }).then((res) => {
        const { question } = res.data;
        this.form = question;
      });
    },
  },
  computed: {
    formTitle() {
      if (!this.isEdit) {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
  },
  validations: {
    form: {
      text: {
        required,
        minLength: minLength(5),
        maxWords: maxWords(1000),
      },
      hint: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(255),
      },
      is_visible: {
        required,
      },
      question_group_id: {
        required,
      },
    },
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.itemIndex = null;
          this.resetData();
        }
      },
      immediate: true,
    },
  },
};
</script>

